<template>
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.29047 2.10833C7.62178 1.95542 8 2.19742 8 2.56231V19.4365C8 19.8014 7.62178 20.0434 7.29047 19.8905L2.79047 17.8136C2.6134 17.7318 2.5 17.5546 2.5 17.3596V13.9994H1.5V17.3596C1.5 17.9446 1.84019 18.4763 2.37141 18.7215L6.87141 20.7984C7.86534 21.2572 9 20.5312 9 19.4365V2.56231C9 1.46763 7.86534 0.741639 6.87141 1.20038L2.37141 3.2773C1.84019 3.52248 1.5 4.05416 1.5 4.63924V7.9994H2.5V4.63924C2.5 4.44421 2.6134 4.26698 2.79047 4.18526L7.29047 2.10833Z" fill="currentColor"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.7095 2.10833C14.3782 1.95542 14 2.19742 14 2.56231V19.4365C14 19.8014 14.3782 20.0434 14.7095 19.8905L19.2095 17.8136C19.3866 17.7318 19.5 17.5546 19.5 17.3596V13.9994H20.5V17.3596C20.5 17.9446 20.1598 18.4763 19.6286 18.7215L15.1286 20.7984C14.1347 21.2572 13 20.5312 13 19.4365V2.56231C13 1.46763 14.1347 0.741639 15.1286 1.20038L19.6286 3.2773C20.1598 3.52248 20.5 4.05416 20.5 4.63924V7.9994H19.5V4.63924C19.5 4.44421 19.3866 4.26698 19.2095 4.18526L14.7095 2.10833Z" fill="currentColor"/>
        <path d="M2 11H6M6 11L4 9M6 11L4 13" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M20 11H16M16 11L18 9M16 11L18 13" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>

<script>
export default {
    name: 'SVGCloseDoors',
};
</script>

<style scoped lang="scss">

</style>
